import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home as HomeIcon, LayoutGrid, MapPin, Compass, Route } from 'lucide-react';
import axios from 'axios';
import CategoriesPanel from '@/components/CategoriesPanel';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [categories, setCategories] = useState([]);
  const [panelOpen, setPanelOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/categories`)
      .then(res => { if (mounted) setCategories(res.data || []); })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  const isActive = (path) => {
    if (path === '/home') return location.pathname === '/home' || location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const items = [
    { key: 'home', label: 'Inicio', icon: HomeIcon, onClick: () => navigate('/home'), active: isActive('/home') },
    { key: 'categories', label: 'Categorías', icon: LayoutGrid, onClick: () => setPanelOpen(true), active: panelOpen },
    { key: 'map', label: 'Mapa', icon: MapPin, onClick: () => navigate('/map'), active: isActive('/map') },
    { key: 'explorer', label: 'Explorador', icon: Compass, onClick: () => navigate('/explorador'), active: isActive('/explorador') },
    { key: 'excursion', label: 'Excursión', icon: Route, onClick: () => navigate('/excursion'), active: isActive('/excursion') },
  ];

  return (
    <>
      <nav
        data-testid="bottom-nav"
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.06)]"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        <div className="flex items-center justify-around px-1 py-2">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                data-testid={`bottom-nav-${item.key}`}
                onClick={item.onClick}
                className={`flex-1 flex flex-col items-center gap-1 py-1.5 px-1 rounded-xl transition-colors ${
                  item.active ? 'text-primary' : 'text-muted-foreground hover:text-primary'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="text-[10px] font-semibold leading-none">{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
      <CategoriesPanel open={panelOpen} onClose={() => setPanelOpen(false)} categories={categories} />
    </>
  );
}
